import { FileReader, FileWriter } from '@/platform'
import FileName from '../../ComControl/FileName'

class NameDialogData {
    public x: number = 0
    public y: number = 0 //文字的xy坐标
    public BackPic: FileName = new FileName() //背景图
    public P_x: number = 0
    public P_y: number = 0 //背景图相对坐标
    public IsCenter: boolean = false //姓名是否居中

    // 姓名框的Y坐标
    get Y(): number {
        return this.y
    }
    set Y(value: number) {
        if (value > 2000) {
            this.y = 2000
        } else if (value < -2000) {
            this.y = -2000
        } else {
            this.y = value
        }
    }

    // 姓名框的X坐标
    get X(): number {
        return this.x
    }
    set X(value: number) {
        if (value > 2000) {
            this.x = 2000
        } else if (value < -2000) {
            this.x = -2000
        } else {
            this.x = value
        }
    }

    constructor()
    constructor(option?: { x: number; y: number; backPic: FileName; pX: number; pY: number }) {
        if (option !== undefined) {
            this.x = option.x
            this.y = option.y
            this.BackPic = option.backPic
            this.P_x = option.pX
            this.P_y = option.pY
            this.IsCenter = false
        } else {
        }
    }

    /** cg_v3_data：X → Y → BackPic → P_x → P_y → IsCenter */
    readBin(reader: FileReader): void {
        this.x = reader.readInt()
        this.y = reader.readInt()
        this.BackPic = new FileName(reader)
        this.P_x = reader.readInt()
        this.P_y = reader.readInt()
        this.IsCenter = reader.readBool()
    }

    writeBin(writer: FileWriter): void {
        writer.writeInt(this.x)
        writer.writeInt(this.y)
        this.BackPic.writeBin(writer)
        writer.writeInt(this.P_x)
        writer.writeInt(this.P_y)
        writer.writeBool(this.IsCenter)
    }

    readVersionedOui(reader: FileReader): void {
        this.x = reader.readInt()
        this.y = reader.readInt()
        this.BackPic.readVersionedOui(reader.readObj(reader.readInt()))
        this.IsCenter = reader.readInt() ? true : false
        this.P_x = reader.readInt()
        this.P_y = reader.readInt()
    }

    writeVersionedOui(writer: FileWriter): void {
        writer.writerIntLength()

        writer.writeInt(this.x)
        writer.writeInt(this.y)
        this.BackPic.writeVersionedOui(writer)
        writer.writeInt(this.IsCenter ? 1 : 0)
        writer.writeInt(this.P_x)
        writer.writeInt(this.P_y)
        writer.writerLength()
    }

    writeGameBin(writer: FileWriter): void {
        this.writeVersionedOui(writer)
    }
}

export default NameDialogData
